module.exports = __webpack_public_path__ + "static/media/learning-14.1c2d37dd.png";